import type { ICart } from "@repo/shopify/queries/cart-gql";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface ICartStore {
  cart: ICart["cart"];
  updateCart: (cart: ICart["cart"]) => void;
}

const initCart: ICart = {
  cart: {
    attributes: [],
    deliveryGroups: {
      edges: [],
      nodes: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
      },
    },
    estimatedCost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      subtotalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      totalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
    },
    checkoutUrl: "",
    createdAt: "",
    metafields: [],
    updatedAt: "",
    buyerIdentity: {
      deliveryAddressPreferences: [],
      walletPreferences: [],
    },
    cost: {
      checkoutChargeAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      subtotalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      totalAmount: {
        amount: "",
        currencyCode: "KRW",
      },
      __typename: "CartCost",
      subtotalAmountEstimated: false,
      totalAmountEstimated: false,
      totalDutyAmountEstimated: false,
      totalTaxAmountEstimated: false,
    },
    discountAllocations: [],
    discountCodes: [],
    id: "",
    lines: {
      edges: [],
      nodes: [],
      pageInfo: {
        endCursor: undefined,
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: undefined,
      },
    },
    totalQuantity: 0,
  },
};

const localLang = localStorage.getItem("i18nextLng") || "ko";

export const useCartStore = create<ICartStore>()(
  persist(
    (set) => ({
      // 초기값
      ...initCart,

      // 함수
      updateCart: (cart: ICart["cart"]) => {
        set(() => ({ cart }));
      },
    }),
    {
      name: `${localLang}-cart`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
